import React from "react";
import { Select, Table } from "antd";
import Header from "../../common/Header";
import societies_icn from "../../../../assets/images/societies-icn.svg";
import registration_icn from "../../../../assets/images/registrations.svg";
import search_icn from "../../../../assets/images/search-1.svg";
import cross_icn from "../../../../assets/images/cross.svg";

const ComplaintsComponent = (props) => {
  const {
    handelComplaintStatusType,
    complaintFilters,
    societies_table_columns,
    complaint_table_data,
    setSearchText,
    complaint_count,
    handelComplaintFilterClear,
    searchText,
    isClearDisabled,
  } = props;

  return (
    <React.Fragment>
      <Header title="Complaints" />
      <div className="complaints-main">
        <div className="complaints-first">
          <div className="left-section">
            <h1>Complaints List</h1>
            <p className="dec-text">
              Monitor society complaints with essential details and filtering
              for streamlined resolution.
            </p>
          </div>
          <div className="right-section">
            <div className="card-1 card">
              <img src={societies_icn} alt="" />
              <div className="details">
                <h1>
                  {complaint_count?.total_complain_count
                    ? complaint_count.total_complain_count
                    : 0}
                </h1>
                <p>Total Complaints</p>
              </div>
            </div>
            <div className="card-2 card">
              <img src={registration_icn} alt="" />
              <div className="details">
                <h1>
                  {complaint_count?.resolved_complaint_count
                    ? complaint_count.resolved_complaint_count
                    : 0}
                </h1>
                <p>Resolved Complaints </p>
              </div>
            </div>
          </div>
        </div>
        <div className="complaints-second">
          <div className="left-section">
            <div className="search-box">
              <img src={search_icn} alt="Search" className="search-icon" />
              <input
                type="text"
                placeholder="Search by Complaint..."
                value={searchText}
                onChange={(e) => setSearchText(e.target.value)}
                style={{
                  flex: 1,
                  border: "none",
                  outline: "none",
                  fontSize: "16px",
                  color: "#333",
                  background: "transparent",
                }}
              />
              {searchText && (
                <button onClick={() => setSearchText("")}>
                  <img src={cross_icn} alt="clear" className="clear-icon" />
                </button>
              )}
            </div>

            <Select
              className="select-status"
              placeholder="Complaint Status"
              onChange={handelComplaintStatusType}
              value={complaintFilters.status}
              filterOption={(input, option) =>
                option.value.toLowerCase().includes(input.toLowerCase())
              }
              allowClear
            >
              <Select.Option value="pending">Pending</Select.Option>
              <Select.Option value="in-progress">In Progress</Select.Option>
              <Select.Option value="resolved">Resolved</Select.Option>
              <Select.Option value="reopen">Reopen</Select.Option>
              <Select.Option value="complete">Complete</Select.Option>
            </Select>
          </div>
          <div className="right-section">
            <button onClick={handelComplaintFilterClear} disabled={isClearDisabled}>
              Clear
            </button>
          </div>
        </div>
        <div className="complaints-list">
          <Table
            dataSource={complaint_table_data}
            columns={societies_table_columns}
            pagination={{
              position: ["bottomCenter"],
              showSizeChanger: true,
              pageSizeOptions: ["10", "25", "50", "100"],
              defaultPageSize: 10,
            }}
            scroll={{ x: "max-content" }}
            className="society-table"
          />
        </div>
      </div>
    </React.Fragment>
  );
};

export default ComplaintsComponent;
